import { Pagination, Table, PaginationProps, TableProps } from "antd";
import "antd/dist/antd.min.css";

interface TabelaInfoProps<T = any> extends TableProps<T> {
  pagination?: PaginationProps;
  idTable? : string | undefined
}

export function TableInfo({
  columns,
  dataSource,
  pagination,
  idTable,
  ...props
}: TabelaInfoProps) {
  return (
    <>
      <div className="w-full flex flex-col mx-auto shadow-3xl" id={idTable}>
        <Table
          id=''
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          {...props}
        />
      </div>

      {pagination ? (
        <Pagination
          className="flex mb-4 mt-4 mr-4 justify-end"
          defaultCurrent={1}
          showSizeChanger={false}
          {...pagination}
          current={pagination.current ?? 0}
          pageSize={pagination.pageSize ?? 0}
          total={pagination.total ?? 0}
        />
      ) : null}
    </>
  );
}